<template>
	<input
		class="kk-radio-button"
		type="radio"
		:checked="inputValue === value"
		:disabled="isDisabled"
		:value="inputValue"
		@input="onInput"
	>
</template>

<script>
export default {
	name: 'KkRadioButton',
	props: {
		value: {
			type: [String, Number, Boolean],
			default: null,
		},
		inputValue: {
			type: [String, Number, Boolean],
			default: null,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		getValueType(type) {
			return Object.prototype.toString.call(this.inputValue) === `[object ${type}]`;
		},
		onInput(e) {
			let currentValue = e.target.value;

			if (this.getValueType('Boolean')) {
				currentValue = JSON.parse(currentValue);
			}

			if (this.getValueType('Number')) {
				currentValue = Number(currentValue);
			}

			this.$emit('input', currentValue);
		}
	},
};
</script>
